<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'系统配置'},{name:'角色权限管理'}]" :title="'角色权限管理'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">名称</span>
                        <el-input v-model="sendInfoOne.roleName" placeholder="角色名称" size="small" clearable></el-input>
                    </div>
                    <div class="child">
                        <span class="name">编码</span>
                        <el-input v-model="sendInfoOne.roleCode" placeholder="角色编码" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                </div>
                <div class="right">
                    <el-button
					 type="primary" size="small" @click="edit()"  icon="el-icon-plus"
					 v-if="authorities.indexOf('sys:permission:background:role:config:list:button:add')!=-1"
					 >添加</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="roleName"
                    show-overflow-tooltip
                    
                    label="角色名称">
                </el-table-column>
                <el-table-column
                    prop="remarks"
                    show-overflow-tooltip
                    
                    width="400"
                    label="描述">
                </el-table-column>
                <el-table-column
                    prop="administratorNum"
                    show-overflow-tooltip
                    
                    label="绑定管理员数">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:role:config:list:button:view')!=-1 ||
                    authorities.indexOf('sys:permission:background:role:config:list:button:edit')!=-1 ||
                    authorities.indexOf('sys:permission:background:role:config:list:button:permission:config')!=-1 ||
                    authorities.indexOf('sys:permission:background:role:config:list:button:delete')!=-1"
                    label="操作"
                    
                    width="400">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="checkDetail(scope.row)" 
						v-if="authorities.indexOf('sys:permission:background:role:config:list:button:view')!=-1"
						>查看</el-button>
                        <el-button size="small" type="primary" class="super" plain  @click="edit(scope.row)" 
						v-if="authorities.indexOf('sys:permission:background:role:config:list:button:edit')!=-1"
						>编辑</el-button>
                        <el-button size="small" type="primary" class="super" plain  @click="authority(scope.row)" 
						v-if="authorities.indexOf('sys:permission:background:role:config:list:button:permission:config')!=-1"
						>权限</el-button>
                        <el-button size="small" type="danger" class="super" plain  @click="del(scope.row)" 
						v-if="authorities.indexOf('sys:permission:background:role:config:list:button:delete')!=-1"
						>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="sendInfoOne.currentPage"
                    :page-sizes="[20, 50, 80, 100]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="角色明细"
                :visible.sync="dialogInfo"
                :close-on-click-modal="false"
                width="50%">
                <div class="basic">
                    <div class="child">
                        <div class="name">角色名称：</div>
                        <div class="content">{{info.roleName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">描述：</div>
                        <div class="content">{{info.remarks}}</div>
                    </div>
                    <div class="child">
                        <div class="name">创建人：</div>
                        <div class="content">{{info.createName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">创建时间：</div>
                        <div class="content">{{info.createTime}}</div>
                    </div>
                    <div class="child">
                        <div class="name">更新人：</div>
                        <div class="content">{{info.modifyUserName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{info.updateTime}}</div>
                    </div>
                </div>
            </el-dialog>
            <!-- 编辑 -->
            <el-dialog
                title="添加角色"
                :visible.sync="dialogEdit"
                :close-on-click-modal="false"
                :before-close="cancel"
                width="30%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>角色名称：</div>
                        <el-input v-model="sendInfoTwo.roleName" maxlength="20"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.roleName']">错误提示：{{errors['sendInfoTwo.roleName']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>角色编码：</div>
                        <el-input v-model="sendInfoTwo.roleCode" maxlength="50"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.roleCode']">错误提示：{{errors['sendInfoTwo.roleCode']}}</div>
                    <div class="childTextarea">
                        <div class="name">说明：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfoTwo.remarks" show-word-limit maxlength="50"></el-input></div>
                    </div>
                    <div class="doubleBtn">
                        <el-button type="primary" @click="cancel">取消</el-button>
                        <el-button type="primary" @click="submit">确认</el-button>
                    </div>
                </div>
            </el-dialog>
            <!-- 权限 -->
            <el-dialog
                title="权限管理"
                :visible.sync="dialogAuthority"
                :before-close="cancels"
                :close-on-click-modal="false"
                width="30%">
                <div class="forms">
                    <div class="child">
                        <div class="name">角色名称：</div>
                        <div class="content">{{autName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">权限配置：</div>
                    </div>
                    <div class="tree">
                        <el-card class="box-card cardLeft">
                            <div slot="header" class="clearfix">
                                <span>菜单权限设置</span>
                            </div>
                            <el-tree
                                :empty-text="'暂无权限'"
                                show-checkbox
                                node-key="id"
                                :default-checked-keys="treeCheck"
                                highlight-current
                                :data="treeList"
                                ref="tree"
                                >
                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                    <span>{{ data.permissionName }}</span>
                                </span>
                            </el-tree>
                        </el-card>
                        <!-- <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>功能权限设置</span>
                            </div>
                            <el-checkbox v-model="checkAll " :indeterminate="isIndeterminate" @change="handleCheckAllChange" v-show="checkList.length>0">全选</el-checkbox>
                            <el-checkbox-group v-model="checkResult" @change="handleCheckedCitiesChange">
                                <el-checkbox v-for="(item,index) in checkList" :label="item.id" :key="index">{{item.permissionName}}</el-checkbox>
                            </el-checkbox-group>
                        </el-card> -->
                    </div>
                    <div class="doubleBtn">
                        <el-button type="primary" @click="cancels">取消</el-button>
                        <el-button type="primary" @click="submits">确认</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        // breadcrumb
    },
    data(){
        return{
          loading:false,
          bHeight: void 0,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:20,//页条数
                roleName:null,//角色名称
                roleCode:null,//角色编码
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            totalSize:null,//总跳数
            tableData:[],//表格数据

            dialogInfo:false,//查看明细弹出层
            info:{},//明细

            dialogEdit:false,//编辑弹出层
            editTitle:'',//弹出层标题
            sendInfoTwo:{
                id:null,//角色id
                roleName:null,//角色名称：
                roleCode:null,//角色编码
                remarks:null,//描述
            },//编辑提交数据

            dialogAuthority:false,//权限弹出层
            autName:'',//管理员名称
            autId:'',//权限id

            treeList: [],//左边树状数组
            checkList:[],//右边多选框数组
            isIndeterminate:false,//全选样式
            checkAll :false,//全选
            checkResult:[],//右边多选框触发数据选中
            treeCheck:[],//点击右边使左边父元素被选中 左边被选中数据赋值
            currentIndex:null,//当前右边数组所属父级最顶层顺序 用以全选时递归当前顺序的数组而不递归整个数
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    vuerify: {
        'sendInfoTwo.roleName':{
            test:'realName',
            message:'角色名称错误'
        },
        'sendInfoTwo.roleCode':{
            test:/^[A-Za-z]{1,50}$/,
            message:'角色编码错误'
        }
    },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //获取数据
        getData:function(){
            this.loading = true
            this.$axiosz.get('backstage/sysRole',{params:this.sendInfoOne}).then((r)=>{
                this.loading = false
                if(r.code==200){
                    this.tableData=r.data.content;
                    this.totalSize=r.data.totalElements;
                }else{
                    this.$alert(r.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        },
        //查看明细
        checkDetail:function(row){
            // this.$axiosz.get('backstage/sysRole/view/'+row.id).then((r)=>{
            //     if(r.code==200){
            //         this.info=r.data;
            //         this.dialogInfo=true;
            //     }else{
            //         this.$alert(r.msg)
            //     }
            // })
            this.$router.push({path: `/systemLayout/character/detail/${row.id}`, query: {index: '/systemLayout/character'},param:{id:row.id}})
        },
        //打开编辑和发布
        edit:function(row){
            if(row){ //编辑
                // this.$axiosz.get('backstage/sysRole/view/'+row.id).then((r)=>{
                //     if(r.code==200){
                //         this.editTitle='编辑角色';
                //         this.dialogEdit=true;
                //         this.$vuerify.clear();
                //         this.sendInfoTwo.id=row.id;
                //         this.sendInfoTwo.roleName=r.data.roleName;
                //         this.sendInfoTwo.roleCode=r.data.roleCode;
                //         this.sendInfoTwo.remarks=r.data.remarks;
                //     }else{
                //         this.$alert(r.msg)
                //     }
                // })
                this.$router.push({path: `/systemLayout/character/edit/${row.id}`, query: {index: '/systemLayout/character'},param:{id:row.id}})
            }else{  //发布
                // this.editTitle='添加角色';
                // this.dialogEdit=true;
                // this.$vuerify.clear();
                this.$router.push({path: `/systemLayout/character/add`, query: {index: '/systemLayout/character'}})
            }
        },
        //编辑取消按钮
        cancel:function(){
            this.dialogEdit=false;
            this.editTitle='';
            this.sendInfoTwo.id=null;
            this.sendInfoTwo.roleName=null;
            this.sendInfoTwo.roleCode=null;
            this.sendInfoTwo.remarks=null;
        },
        //编辑保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check(['sendInfoTwo.roleName','sendInfoTwo.roleCode'])){
                if(this.sendInfoTwo.id){//编辑
                    this.$axiosz.put("backstage/sysRole/"+this.sendInfoTwo.id,this.$qs.stringify(this.sendInfoTwo)).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                message: this.editTitle+'成功！',
                                type: 'success'
                            });
                            this.dialogEdit=false;
                            this.getData();
                        }else{
                            this.$alert(r.msg)
                        }
                    })
                }else{ //发布
                    this.$axiosz.post("backstage/sysRole",this.$qs.stringify(this.sendInfoTwo)).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                message: this.editTitle+'成功！',
                                type: 'success'
                            });
                            this.dialogEdit=false;
                            this.getData();
                        }else{
                            this.$alert(r.msg)
                        }
                    })
                }
                
            }
        },

        //数据去重
        deweight:function(arr){
            let i,
            obj = {},
            result = [],
            len = arr.length;
            for(i = 0; i< arr.length; i++){
                if(!obj[arr[i]]){ //如果能查找到，证明数组元素重复了
                    obj[arr[i]] = 1;
                    result.push(arr[i]);
                }
            }
            return result;
        },
        //建立数组树结构 菜单权限设置
        buildTree(list){
            for(let i = 0 ,len = list.length ; i < len ; i++){
                // if(list[i].type==1 && list[i].sysPermissionVoList &&list[i].sysPermissionVoList[0].type==2) continue;
                list[i].lable=list[i].permissionName
                if(list[i].sysPermissionVoList && list[i].sysPermissionVoList.length > 0){
                    list[i].children=list[i].sysPermissionVoList
                }
                if(list[i].sysPermissionVoList && list[i].sysPermissionVoList.length > 0){
                    this.buildTree(list[i].sysPermissionVoList);
                }
                if(list[i].type == 2){
                    list[i].permissionName =  list[i].permissionName + '-按钮'
                }
            }
            return list;
        },
        //递归父级id
        recursion:function(list,id,lists){
            for(let item of list){
                if(item.id===id && item.type!=0 && item.type!=1){
                    if(this.treeCheck.indexOf(item.parentId) < 0){
                        this.treeCheck.push(item.parentId);
                    }
                }else if(item.sysPermissionVoList && item.sysPermissionVoList.length>0){
                        this.recursion(item.sysPermissionVoList,id,lists);
                }
            }
            return this.treeCheck;
        },
        recursionDelete:function(list,id,lists,parentId){
            list.forEach((item,n) => {
                if(item.id==id && item.type!=0 && item.type==2){
                    if(parentId){
                        if(this.treeCheck.indexOf(parentId) > -1){
                            this.treeCheck.splice(this.treeCheck.indexOf(parentId),1)
                        }
                    }
                }else if(item.sysPermissionVoList && item.sysPermissionVoList.length>0){
                        this.recursionDelete(item.sysPermissionVoList,id,lists,item.id);
                }
            })
            return this.treeCheck;
        },
        //获取权限回显
        setAut:function(list){
            for(let item of list){
                if(item.isSelected==1 && !item.sysPermissionVoList){
                    this.treeCheck.push(item.id); //将左边最后一级赋值选中 插件自动将父级半选中 提交可获取
                    this.treeCheck=this.deweight(this.treeCheck);
                }
                if(item.sysPermissionVoList && item.sysPermissionVoList.length > 0){
                    this.setAut(item.sysPermissionVoList);
                }
                
                // if(item.type  == 0  && !item.sysPermissionVoList){
                //     if(item.isSelected==1){
                //         this.treeCheck.push(item.id); //将左边最后一级赋值选中 插件自动将父级半选中 提交可获取
                //         this.treeCheck=this.deweight(this.treeCheck);
                //     }
                // }
                // if(item.type==1 && item.sysPermissionVoList && item.sysPermissionVoList.length > 0){
                //     if(item.sysPermissionVoList[0].type==2){
                //         if(item.isSelected==1){
                //             this.treeCheck.push(item.id); //将左边最后一级赋值选中 插件自动将父级半选中 提交可获取
                //             this.treeCheck=this.deweight(this.treeCheck);
                //         }
                //         // for(let items of item.sysPermissionVoList){
                //         //     if(items.isSelected===1){
                //         //         this.checkResult.push(items.id);//将右边复选框的选中项选中
                //         //     }
                //         // }
                //     }else{
                //         this.setAut(item.sysPermissionVoList,lists);
                //     }
                // }else if(item.type!=1 && item.sysPermissionVoList && item.sysPermissionVoList.length>0){
                //     this.setAut(item.sysPermissionVoList,lists);
                // }
            }
        },
        //点击树的复选框删除右边 对应的选中项
        delCheck:function(obj){
            if(obj.type==1 && obj.sysPermissionVoList && obj.sysPermissionVoList.length>0){
                if(obj.sysPermissionVoList[0].type==2){
                    this.checkResult=this.deleteBouth(this.checkResult,obj.sysPermissionVoList);
                }else{
                    for(let item of obj.sysPermissionVoList){
                        this.delCheck(item);
                    }
                }
                if(obj.sysPermissionVoList[0].id==this.checkList[0].id){
                    this.checkAll=false;
                    this.isIndeterminate=false;
                }
            }else if(obj.type!=1 && obj.sysPermissionVoList && obj.sysPermissionVoList.length>0){
                for(let item of obj.sysPermissionVoList){
                    this.delCheck(item);
                }
            }
        },
        //权限
        authority:function(row){
            // this.$axiosz.get('backstage/sysPermission/roleId/'+row.id).then((r)=>{
            //     if(r.code==200){
            //         this.$vuerify.clear();
            //         this.dialogAuthority=true;
            //         this.autName=row.roleName;
            //         this.autId=row.id;
            //         // this.treeList = r.data
            //         this.treeList=this.buildTree(r.data);
            //         this.setAut(this.treeList);
            //         console.log(this.treeCheck.length)
            //     }else{
            //         this.$alert(r.msg)
            //     }
            // })
            this.$router.push({path: `/systemLayout/character/auth/${row.id}`, query: {index: '/systemLayout/character'},param:{id:row.id}})
        },
        //节点点击获取右边权限列表
        nodeClick:function(obj,node,ui){
            if(obj.sysPermissionVoList && obj.sysPermissionVoList.length>0 && obj.sysPermissionVoList[0].type==2){ //首页无权限
                this.checkList=obj.sysPermissionVoList;
                this.checkAll=false;
                this.currentIndex=obj.parentSort;
                //设置全选按钮状态
                let checkAllList=[];
                for(let i in this.checkResult){
                    for(let j in this.checkList){ //右边展示数组
                        if(this.checkResult[i]==this.checkList[j].id){
                            checkAllList.push(this.checkResult[i]);//临时存储相同数据的数组
                        }
                    }
                }
                if(checkAllList.length>0 && checkAllList.length==this.checkList.length){
                    this.checkAll=true;//如果全选中则将全选按钮选中
                    this.isIndeterminate=false;
                }else if(checkAllList.length>0 && checkAllList.length<this.checkList.length){
                    this.checkAll=false;
                    this.isIndeterminate=true;
                }else{
                    this.checkAll=false;
                    this.isIndeterminate=false;
                }
            }
        },
        // 删除两个数组的相同值 取前一个数组删除后结果
        deleteBouth:function(arr1,arr2){
            arr1= arr1.filter(item => {
                let idList= arr2.map(v => v.id)
                return !idList.includes(item)
            })
            return arr1;
        },
        //点击树的复选框 进行数据的操作
        // check:function(objOne,objTwo){
        //     let endArr=[...this.$refs.tree.getCheckedKeys(),...this.$refs.tree.getHalfCheckedKeys()];
		// 	// console.log('endArr='+JSON.stringify(endArr))
        //     let flag=true; //判断是否有相同项用以删除
        //     if(endArr.length>0){
        //         for(let item of endArr){
        //             if(item==objOne.id){//表示删除项 当点击后有相同项 表示是选中状态
        //                 flag=false;
        //             }
        //         }
        //         if(flag){
        //             this.delCheck(objOne);
        //         }
        //     }else{ //表示全部为空 直接删除
        //         this.delCheck(objOne);
        //     }
        // },
        //右边全选按钮
        handleCheckAllChange:function(val){
            // this.treeCheck=[];
            if(val){
                for(let item of this.checkList){
                    this.checkResult.push(item.id);
                }
                this.checkResult=this.deweight(this.checkResult); //去重
                let forAry=[];
                for(let item of this.treeList){
                    if(item.sort==this.currentIndex){
                        forAry=item.sysPermissionVoList;
                    }
                }
                // for(let item of this.checkResult){
                //     this.treeCheck=[...this.treeCheck,...this.recursion(forAry,item,forAry)];
                // }
                this.treeCheck=[...this.treeCheck,...this.recursion(forAry,this.checkList[0].id,forAry)];
                this.treeCheck=this.deweight(this.treeCheck);
                this.$refs.tree.setCheckedKeys(this.deweight(this.treeCheck)); //设置树选中项
            }else{
                this.checkResult=this.deleteBouth(this.checkResult,this.checkList);
            }
            this.isIndeterminate=false;
        },
        //点击 右边功能按钮权限 复选框
        handleCheckedCitiesChange(value) {
            // console.log(value)
            // console.log(this.checkList)
            let ary = [];
            this.checkList.forEach(m => {
                if(value.indexOf(m.id) > -1){
                    ary.push(m.id)
                }
            })
            let checkedCount = ary.length;
            this.checkAll  = checkedCount === this.checkList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkList.length;
            //点击单选框时将左边父级选中 得到父级id
            if(ary && ary.length > 0){
                this.treeCheck=this.recursion(this.treeList,ary[0],this.treeList);
                this.$refs.tree.setCheckedKeys(this.deweight(this.treeCheck)); //设置树选中项
            }else{
                // console.log('不选='+JSON.stringify(this.treeCheck))
                this.treeCheck=this.recursionDelete(this.treeList,this.checkList[0].id,this.treeList);
                // this.treeCheck=this.recursionDelete(this.treeList,ary[0],this.treeList);
                this.$refs.tree.setCheckedKeys(this.deweight(this.treeCheck)); //设置树选中项
			}
        },
        //权限取消按钮
        cancels:function(){
            this.dialogAuthority=false;
            this.treeList= [];//左边树状数组
            this.checkList=[];//右边多选框数组
            this.isIndeterminate=false;//全选样式
            this.checkAll=false;//全选
            this.checkResult=[];//右边多选框触发数据
            this.treeCheck=[];//点击右边使左边父元素被选中 左边被选中数据赋值
        },
        //权限保存按钮
        submits:function(){
            // console.log(this.$refs.tree.getCheckedKeys(),this.$refs.tree.getHalfCheckedKeys()); //左边 已选中 和 半选中
            // console.log(this.$refs.tree.getHalfCheckedKeys) ; //复选框当前数据
            // console.log(this.$refs.tree.getCheckedKeys())
            // console.log(1111111111)
            // console.log(...this.$refs.tree.getHalfCheckedKeys())
            let endArr = [];
            if(this.$refs.tree.getHalfCheckedKeys()){
                endArr=[...this.$refs.tree.getCheckedKeys(),...this.$refs.tree.getHalfCheckedKeys()];
            }else{
                endArr=[...this.$refs.tree.getCheckedKeys()];
            }
            let formData = new FormData();
            for(let item of endArr){
                formData.append("ids",item);
            }
            console.log(endArr.length)
            this.$axiosz.post('backstage/sysRole/permission/'+this.autId,formData).then((r)=>{
                if(r.code==200){
                    this.$message({
                        type: 'success',
                        message: '设置权限成功!'
                    });
                    this.getData();
                    this.cancels();
                }else{
                    this.$alert(r.msg)
                }
            })
        },
        //删除按钮
        del:function(row){
            this.sendInfoTwo.id=row.id;
            this.sendInfoTwo.roleName=row.roleName;
            this.sendInfoTwo.roleCode=row.roleCode;
            this.sendInfoTwo.remarks=row.remarks;
            this.$confirm('是否删除？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axiosz.delete('backstage/sysRole/'+row.id,{params:this.sendInfoTwo}).then((r)=>{
                    if(r.code==200){
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.dialogAuthority=false;
                        this.getData();
                    }else{
                        this.$alert(r.msg);
                    }
                    this.sendInfoTwo.id=null;
                    this.sendInfoTwo.roleName=null;
                    this.sendInfoTwo.roleCode=null;
                    this.sendInfoTwo.remarks=null;
                })
            }).catch(() => {});
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
    },
    mounted(){
        const that = this
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    },
    watch:{
        treeCheck(n,o){
            console.log(n)
        }
    }
}
</script>

<style lang="scss" scoped>
.cardLeft{
    // /deep/ .el-checkbox{
    //         display: none;
    //     }
    // /deep/ .is-leaf+.el-checkbox{
    //         display: block;
    // }
}
</style>